import Components from "../components";

class PrettyPrint extends Components.Base {
  initialize() {
    window.prettyPrint();
  }
}

Components.collection.register({ selector: 'body', klass: PrettyPrint });
